import { getStore, setStore } from '@/utils/session'

// initial state
const state = {
  bankInfo: getStore('bankInfo') ? getStore('bankInfo') : null,
  sAppInfo: getStore('sAppInfo') ? getStore('sAppInfo') : null
}

// getters
const getters = {
  getBankInfo: (state) => state.bankInfo,
  sAppInfo: (state) => state.sAppInfo
}

// mutations
const mutations = {
  SET_BANK_INFO(state, bankInfo) {
    state.bankInfo = bankInfo
    setStore('bankInfo', bankInfo)
  },
  SET_S_APP_INFO(state, sAppInfo) {
    state.sAppInfo = sAppInfo
    setStore('sAppInfo', sAppInfo)
  }
}

export default {
  state,
  getters,
  mutations
}
